import { CircularProgress, Typography } from "@mui/material";
import { useParams } from "react-router";
import { useApiQuery } from "../hooks/use-api-query.ts";
import type { DiscoveryRun } from "../types.ts";
import DiscoveryRunDetailsPage from "./discovery-run-details.tsx";
import DiscoveryRunDetailsV1Page from "./discovery-run-details-v1.tsx";

export default function DiscoveryRunDetailsRouter() {
  const { runId } = useParams();

  const { data, isLoading, error } = useApiQuery<DiscoveryRun>(`/discovery-runs/${runId}`, {
    enabled: !!runId,
  });

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error || !data) {
    return <Typography>Discovery Run for id "{runId}" not found</Typography>;
  }

  // Route to appropriate component based on version
  if (["v1", "v3"].includes(data.version ?? "v0")) {
    return <DiscoveryRunDetailsV1Page />;
  }

  // Default to v0 (original) component
  return <DiscoveryRunDetailsPage />;
}
